import React from 'react'

import {
    ItemSectionDiv,
    AppTypeItemDiv,
    AppTypeNameDiv,
} from  '../../Styles/Components/AppTypeItemStyles'

import  {
    generateDisplayName
} from '../../Utilities/HubTools'

import { useDispatch } from "react-redux"
import { setHubPage } from '../../Redux/Slices/HubSlice'

function AppTypeItem(props){
    const dispatch = useDispatch()

    const appType = props.appType
    const appTypeName = generateDisplayName(appType)

    function onClick(){
        dispatch(setHubPage({hubPage: appType}))
    }

    return (
        <AppTypeItemDiv onClick={onClick}>
            <ItemSectionDiv>
                <AppTypeNameDiv>
                    {appTypeName}
                </AppTypeNameDiv>
            </ItemSectionDiv>
        </AppTypeItemDiv>
    )
}

export default AppTypeItem